// import styles from './TitleGroup.module.scss'

// import { useEffect, useRef } from 'react'
// import { gsap, Power4 } from 'gsap'

// import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
// gsap.registerPlugin(ScrollTrigger)

// const tweenVars: gsap.TimelineVars = {
//   y: '50',
//   duration: 1,
//   opacity: 0,
//   ease: Power4.easeOut,
// }

// interface Props {
//   isAnimationOn: boolean
// }

// const TitleGroup: React.FC<Props> = ({ isAnimationOn }) => {
//   const timeline = gsap.timeline()

//   const wrapper = useRef<HTMLDivElement>()
//   const color_box = useRef<HTMLDivElement>()
//   const mini_title = useRef<HTMLDivElement>()
//   const main_title = useRef<HTMLDivElement>()
//   const title_text = useRef<HTMLDivElement>()

//   useEffect(() => {
//     if (isAnimationOn == false) {
//       timeline.to(wrapper.current, { css: { opacity: 1 } }, 0)
//       // no animation
//     } else {
//       gsap.from(color_box.current, {
//         x: '-1100',
//         duration: 3,
//         opacity: 1,
//         ease: Power4.easeOut,
//       })

//       timeline
//         .to(wrapper.current, { css: { opacity: 1 } }, 0)
//         .from(mini_title.current, tweenVars, 0.2)
//         .from(main_title.current, tweenVars, 0.4)
//         .from(title_text.current, tweenVars, 0.6)
//     }

//     ScrollTrigger.create({
//       animation: timeline,
//       trigger: mini_title.current,
//       start: 'top center',
//       toggleActions: 'play none none reverse',
//     })
//   }, [])

//   return (
//     <section className={styles.contents} ref={wrapper}>
//       <div className={styles.colorBox} ref={color_box}></div>
//       <div className={styles.title_group}>
//         <p className={styles.normal_text} ref={mini_title}>
//           トピックス
//         </p>
//         <h1 className={styles.title} ref={main_title}>
//           Topics
//         </h1>
//         <div className={styles.title_text_group}>
//           <p className={styles.sub_text} ref={title_text}>
//             弊社に関する最新情報を発信しています。
//           </p>
//         </div>
//       </div>
//       <div id="paginationTarget"></div>
//     </section>
//   )
// }

// export default TitleGroup

interface PageMainTitle {
  category: string
  title: string
  sub_title: string
  sub_title2: string
  text: string
}

export const pageMainTitle: PageMainTitle = {
  category: 'トピックス',
  title: 'Topics',
  sub_title: '',
  sub_title2: '',
  text:
    '',
}

